import { useState, type FormEvent } from "react";
import { fieldCls } from "./AuthShell.js";
import { Modal } from "./ui/Modal.js";
import { Button } from "./ui/Button.js";

export function GuestNamePrompt({ open, onComplete }: { open: boolean; onComplete: (name: string) => void }) {
  const [name, setName] = useState("");
  function submit(event: FormEvent) {
    event.preventDefault();
    onComplete(name.trim() || "Guest");
  }
  return <Modal open={open} onClose={() => undefined} labelledBy="guestNameTitle">
    <form onSubmit={submit} className="space-y-4">
      <div>
        <h2 id="guestNameTitle" className="text-lg font-semibold text-ink">What should we call you?</h2>
        <p className="mt-1 text-sm text-muted">Your name appears beside changes you make to this checklist.</p>
      </div>
      <input className={fieldCls} value={name} maxLength={40} autoFocus placeholder="Your name" onChange={(event) => setName(event.target.value)} />
      <div className="flex flex-wrap gap-2">
        <Button type="submit">Continue</Button>
        <Button type="button" variant="secondary" onClick={() => onComplete("Guest")}>Continue as Guest</Button>
      </div>
    </form>
  </Modal>;
}
